import axios from "../axiosConfig";
import { ENDPOINT_APP_ADD, ENDPOINT_APP_ICON, ENDPOINT_APP_REMOVE, ENDPOINT_APP_UPDATE, ENDPOINT_APPS, ENDPOINT_CLIENT_ADD, ENDPOINT_CLIENT_UPDATE, ENDPOINT_CLIENT_REMOVE } from "../../constants";
import { AppData } from "./data";

export function retrieveApps(): Promise<any> {
    return new Promise<string>(async (resolve, reject) => {
        axios.get(ENDPOINT_APPS, { withCredentials: true }).then(res => {
            console.log(res.data)

            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}


export function addApp(app: AppData): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_APP_ADD, app, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}

export function removeApp(app: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_APP_REMOVE + "?id=" + app, {}, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}

export function removeClient(client: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_CLIENT_REMOVE + "?id=" + client, {}, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}


export function updateApp(app: AppData): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_APP_UPDATE, app, { withCredentials: true }).then(res => {
            console.log(res.data)

            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}

export function addClient(
    app: string,
    desc: string,
    redirect: string,
    platform: string,
    domain: string,
    customHash: boolean,
    sessionActivityTimeout?: number,
    sessionTTL?: number,
    allowDelete?: boolean,
    allowMultipleSessions?: boolean,
    deviceLimit?: number,
    loginRetryLimit?: number,
    newSessionOnReauth?: boolean
): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        const payload: any = {
            desc: desc,
            app: app,
            platform: platform,
            redirect: redirect,
            domain: domain,
            custom_hash: customHash,
            allow_delete: allowDelete || false,
            allow_multiple_sessions: allowMultipleSessions !== false,
            new_session_on_reauth: newSessionOnReauth || false
        }

        // Only include timeout fields if they have valid values
        if (sessionActivityTimeout && sessionActivityTimeout > 0) {
            payload.session_activity_timeout = sessionActivityTimeout
        }
        if (sessionTTL && sessionTTL > 0) {
            payload.session_ttl = sessionTTL
        }
        if (deviceLimit && deviceLimit > 0) {
            payload.device_limit = deviceLimit
        }
        if (loginRetryLimit && loginRetryLimit > 0) {
            payload.login_retry_limit = loginRetryLimit
        }

        axios.post(ENDPOINT_CLIENT_ADD, payload, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function updateClient(
    clientId: string,
    desc: string,
    redirect: string,
    platform: string,
    domain: string,
    customHash: boolean,
    sessionActivityTimeout?: number,
    sessionTTL?: number,
    allowDelete?: boolean,
    allowMultipleSessions?: boolean,
    deviceLimit?: number,
    loginRetryLimit?: number,
    newSessionOnReauth?: boolean
): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        const payload: any = {
            id: clientId,
            desc: desc,
            platform: platform,
            redirect: redirect,
            domain: domain,
            custom_hash: customHash,
            allow_delete: allowDelete || false,
            allow_multiple_sessions: allowMultipleSessions,
            new_session_on_reauth: newSessionOnReauth
        }

        // Only include timeout fields if they have valid values
        if (sessionActivityTimeout && sessionActivityTimeout > 0) {
            payload.session_activity_timeout = sessionActivityTimeout
        }
        if (sessionTTL && sessionTTL > 0) {
            payload.session_ttl = sessionTTL
        }
        if (deviceLimit && deviceLimit > 0) {
            payload.device_limit = deviceLimit
        }
        if (loginRetryLimit && loginRetryLimit > 0) {
            payload.login_retry_limit = loginRetryLimit
        }

        axios.post(ENDPOINT_CLIENT_UPDATE, payload, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}
export function uploadIcon(img: File, small: boolean, app: string): Promise<any> {
    const formData = new FormData();
    formData.append('profile', img)
    formData.append('app', app)
    formData.append('fname', img.name)
    if (small) {
        formData.append('small', "true")
    }
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_APP_ICON, formData, {
            withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            console.log(res.data)
            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}